import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PageFooter, PageHeader, WalletDocker } from '@/page-components';
import { memo } from 'react';
import styles from './index.module.less';
export const Layout = memo(({ children }) => {
    return (_jsxs("div", { className: styles.container, children: [_jsx(PageHeader, { className: styles.header }), _jsx("div", { className: styles.body, children: children }), _jsx(PageFooter, { className: styles.footer }), _jsx(WalletDocker, { className: styles.walletDocker })] }));
});
